import React from "react";

import { css } from "@emotion/css";

import { useStyles } from "@/hooks/useStyles.ts";
import { QATools } from "@/pages/QaTools/QaTools.tsx";
import { Page } from "@/uiKit/atoms/page/Page.tsx";
import { PageContent } from "@/uiKit/atoms/page/PageContent.tsx";

export const DevPatientManagementPage: React.FC = () => {
  const styles = useStyles(makeStyles);

  return (
    <Page id="dev-patient-management-page" className={styles.container}>
      <PageContent className={styles.content}>
        <QATools />
      </PageContent>
    </Page>
  );
};

const makeStyles = () => ({
  container: css({}),
  content: css({
    paddingTop: "2vh",
  }),
});
